import { IParamsToSend } from '@base/@types/providers/Kpi/StorageProvider'

export const storageIndicatorsRequest: IParamsToSend = {
  empresa: {
    ids: [],
    agrupar: false
  },
  tipoCentro: {
    ids: [],
    agrupar: false
  },
  loja: {
    ids: [],
    agrupar: false
  },
  gerenteCategoria: {
    ids: [],
    agrupar: false
  },
  gerenteProduto: {
    ids: [],
    agrupar: false
  },
  mundo: {
    ids: [],
    agrupar: false
  },
  categoriaCompacta: {
    ids: [],
    agrupar: false
  },
  categoria: {
    ids: [],
    agrupar: false
  },
  statusEstoque: {
    ids: [],
    agrupar: false
  },
  curvaABC: {
    descricoes: [],
    agrupar: false
  },
  deposito: {
    ids: [],
    agrupar: true
  },
  fornecedor: {
    ids: [],
    agrupar: false
  },
  subCategoria: {
    ids: [],
    agrupar: false
  },
  periodoVendaMedia: 120,
  CMVouEstoque: null,
  periodo: null
}
